/**
 * DevCraft Theme
 * Clean, professional design inspired by Google Material Design
 */

const theme = {
  colors: {
    // Primary colors
    primary: '#1561ED',
    primaryLight: '#4A83F1',
    primaryDark: '#0D47A1',
    primaryHover: '#1252CC',
    
    // Accent colors
    accent: '#1561ED',
    accentLight: '#E8F0FE',
    
    // Success / Error
    success: '#1E8E3E',
    successLight: '#E6F4EA',
    successDark: '#137333',
    
    danger: '#D93025',
    dangerLight: '#FCE8E6',
    dangerDark: '#B31412',
    
    warning: '#F9AB00',
    warningLight: '#FEF7E0',
    
    // Text colors
    text: '#202124',
    textSecondary: '#5F6368',
    textMuted: '#80868B',
    textPlaceholder: '#BDC1C6',
    
    // Backgrounds
    background: '#F8FAFF',
    backgroundAlt: '#F1F3F4',
    backgroundCard: '#F8FAFC',
    backgroundCardDark: '#1E293B',
    backgroundHover: '#F1F3F4',
    
    // Borders
    border: '#DADCE0',
    borderLight: '#E8EAED',
    borderFocus: '#1561ED',
    
    // Gradients
    gradient: {
      primary: 'linear-gradient(135deg, #1561ED 0%, #1252CC 100%)',
      light: 'linear-gradient(180deg, #FFFFFF 0%, #F8FAFF 100%)',
      card: 'linear-gradient(180deg, #FFFFFF 0%, #FAFBFC 100%)',
    },
  },
  
  shadows: {
    xs: '0 1px 2px rgba(60, 64, 67, 0.1)',
    sm: '0 1px 3px rgba(60, 64, 67, 0.15), 0 1px 2px rgba(60, 64, 67, 0.1)',
    md: '0 2px 6px rgba(60, 64, 67, 0.15), 0 1px 3px rgba(60, 64, 67, 0.1)',
    lg: '0 4px 12px rgba(60, 64, 67, 0.15), 0 2px 6px rgba(60, 64, 67, 0.1)',
    xl: '0 8px 24px rgba(60, 64, 67, 0.15), 0 4px 12px rgba(60, 64, 67, 0.1)',
    card: '0 1px 3px rgba(60, 64, 67, 0.1), 0 1px 2px rgba(60, 64, 67, 0.06)',
    cardHover: '0 4px 12px rgba(60, 64, 67, 0.15), 0 2px 6px rgba(60, 64, 67, 0.1)',
    button: '0 1px 3px rgba(21, 97, 237, 0.2), 0 1px 2px rgba(21, 97, 237, 0.15)',
    buttonHover: '0 2px 8px rgba(21, 97, 237, 0.3), 0 2px 4px rgba(21, 97, 237, 0.2)',
    focus: '0 0 0 2px rgba(21, 97, 237, 0.2)',
  },
  
  borderRadius: {
    xs: '4px',
    sm: '6px',
    md: '8px',
    lg: '12px',
    xl: '16px',
    xxl: '24px',
    full: '9999px',
  },
  
  spacing: {
    xs: '4px',
    sm: '8px',
    md: '16px',
    lg: '24px',
    xl: '32px',
    xxl: '48px',
    xxxl: '64px',
  },
  
  fonts: {
    body: "'Google Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    heading: "'Google Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
  },
  
  fontWeights: {
    normal: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
  },
  
  fontSizes: {
    xs: '0.75rem',
    sm: '0.875rem',
    md: '1rem',
    lg: '1.125rem',
    xl: '1.25rem',
    xxl: '1.5rem',
    xxxl: '2rem',
  },
  
  breakpoints: {
    mobile: '480px',
    tablet: '768px',
    desktop: '1024px',
    wide: '1280px',
  },
  
  transitions: {
    fast: '0.1s ease',
    normal: '0.2s ease',
    slow: '0.3s ease',
  },
};

export default theme;
